import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import FontNumber from '../common/FontNumber'
import FlexBox from '../common/FlexBox'
import { Button } from '../common/Button'
import { withI18n } from '../../i18n/util'

const Wrapper = styled.div`
  background: rgba(33, 40, 51, 0.6);
  margin-bottom: 10px;
  border-radius: 3px;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #0b0e11;
  padding: 0 15px;
  height: 40px;
  line-height: 40px;
  font-size: 13px;
  position: relative;
  color: #848e9c;
  .symbol {
    font-size: 14px;
    margin-right: 10px;
    color: #fff;
  }
  .name {
    width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

const Body = styled.div`
  padding: 10px 15px;
  font-size: 13px;
  position: relative;
  .hash {
    font-size: 14px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #fff;
    margin-bottom: 10px;
  }
`

const PriceAndAmount = styled.div`
  .title {
    color: #848e9c;
    width: 46px;
    text-align: left;
    margin-right: 20px;
  }
  .value {
    color: #fff;
    .total {
      font-size: 12px;
      color: #848e9c;
    }
  }
`

const Total = styled(FlexBox)`
  font-size: 14px;
  color: #fff;
  font-weight: 600;
  .title {
    margin-right: 10px;
    color: #fff;
  }
`

const Available = styled(FlexBox)`
  font-size: 14px;
  color: #fff;
  .title {
    color: #848e9c;
    font-size: 13px;
  }
`

const InOrder = styled(FlexBox)`
  position: absolute;
  right: 15px;
  bottom: 10px;
  font-size: 14px;
  color: #fff;
  .title {
    color: #848e9c;
    font-size: 13px;
    margin-right: 10px;
  }
`

const SendButton = styled(Button)`
  width: auto;
  background: rgba(33, 40, 51, 0.6);
  padding: 0 10px;
  height: 24px;
  line-height: 23px;
  border: 1px solid #f0b90b;
  box-sizing: border-box;
  font-size: 13px;
  margin-right: 10px;
  border-color: #f0b90b;
  color: #f0b90b;
  position: absolute;
  right: 15px;
  bottom: 7px;
  &:hover {
    border-color: #f0b90b;
    color: #f0b90b;
  }
  @media (max-width: 768px) {
    width: 60px;
  }
`

class BalanceItem extends PureComponent {
  static propTypes = {
    balance: PropTypes.object,
    history: PropTypes.object,
    send: PropTypes.func,
    locale: PropTypes.string,
  }

  static defaultProps = {
    balance: {},
    history: {},
    send: () => {},
    locale: 'en',
  }

  _send = ev => {
    const {
      history,
      balance: { asset },
      send,
      locale,
    } = this.props
    if (send(ev, asset)) {
      history.push(`/${locale}/balances/${asset}`)
    }
  }

  render() {
    const {
      balance: { name, asset, inOrder, totalBalance, availableBalance },
    } = this.props

    return (
      <Wrapper key={asset}>
        <Header>
          <FlexBox align="center">
            <div className="symbol">{asset}</div>
            <div className="name">{name}</div>
          </FlexBox>
          <SendButton onClick={this._send}>Send</SendButton>
        </Header>
        <Body>
          <FlexBox>
            <PriceAndAmount>
              <Total>
                <div className="title">Total</div>
                <div className="value">
                  <FontNumber value={totalBalance} />
                </div>
              </Total>
              <Available>
                <div className="title">Available</div>
                <div className="value">
                  <FontNumber value={availableBalance} />
                </div>
              </Available>
            </PriceAndAmount>
          </FlexBox>
          <InOrder>
            <div className="title">In Order</div>
            <div className="value">
              <FontNumber value={inOrder} />
            </div>
          </InOrder>
        </Body>
      </Wrapper>
    )
  }
}

export default withI18n(withRouter(BalanceItem))
